import { useContext, createElement } from 'react';
import { ToggleIcon } from './toggle-icon';
import { ProTableSettingContext } from '../contexts/pro-table-setting-context';
export const ProTableCompactButton = () => {
    const { tableSetting, setTableSetting } = useContext(ProTableSettingContext);
    const onSizeChange = () => {
        setTableSetting((oldState) => ({
            ...oldState,
            size: oldState.size === 'small' ? 'medium' : 'small',
        }));
    };
    return (createElement(ToggleIcon, { title: tableSetting.size === 'small' ? '正常模式' : '紧凑模式', type: tableSetting.size === 'small' ? 'table-wide' : 'table-narrow', onClick: onSizeChange }));
};
ProTableCompactButton.displayName = 'ProTableCompactButton';
